<template>
    <q-dialog v-model="dialog">
      <q-card class="my-card justify-center pa-3" flat>
        <div v-if="billingHistory">
          <q-card-section>
            <h1 class="text-h6 text-center">Billing Details</h1>
            <h2 class="text-caption text-center">View details about your past payments</h2>
          </q-card-section>
          <q-card-section>
            <p class="text-caption">Subscription Status: {{billingHistory.status}}</p>
            <p class="text-caption">Created at: {{formatDate(billingHistory.start_time)}}</p>
            <p class="text-caption">Last Payment: {{formatDate(billingHistory.billing_info.last_payment.time)}}</p>
            <p class="text-caption">Amount: {{billingHistory.billing_info.last_payment.amount.currency_code}} {{billingHistory.billing_info.last_payment.amount.value}}</p>
            <p class="text-caption" v-if="billingHistory.status === 'ACTIVE'">Next Payment: {{formatDate(billingHistory.billing_info.next_billing_time)}}</p>

            <q-card-section>
              <q-btn label="Cancel Subscription" color="red" class="full-width" v-if="billingHistory.status === 'ACTIVE'" @click="cancel = true"  />
            </q-card-section>
          </q-card-section>
        </div>
        <q-card-section v-else>
          <p class="text-caption">No details available for this subscription</p>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>

      <confirmation-dialog :subscription="subscription" :confirm="cancel" @cancelled="dialog = false" />
    </q-dialog>
</template>
<script>
import { useQuasar } from 'quasar'
import ConfirmationDialog from "@/components/ConfirmationDialog"
import { ref } from '@vue/reactivity'
import { inject } from '@vue/runtime-core'
export default {
    props: ['subscription'],
    components: {ConfirmationDialog},
    setup(props) {
        const $q = useQuasar()
        const cancel = ref(false)
        const dialog = ref(false)
        const axios = inject('axios')
        const billingHistory = ref(null)
        const formatDate = (val) => {
            let date = new Date(val)
            return date.toGMTString()
        }

        const getBillingHistory = () => {
            axios.get(`${process.env.VUE_APP_URL}/paypal/history/${props.subscription}`)
            .then((resp)=>{
              if (resp.data.name === "RESOURCE_NOT_FOUND"){
                billingHistory.value = null
              } else {
                billingHistory.value = resp.data
              }
              
              dialog.value = true
            })
            .catch((err) => {
              $q.notify({
                message: 'An error has ocurred!',
                caption: 'An error ocurred when searching the current plan data to your place. Wait a few moments and try again.',
                color: 'negative'
              })
            })
        }

        getBillingHistory()

        return { formatDate, cancel, billingHistory, dialog }
    },
}
</script>
